import React from 'react';

import Button from '@material-ui/core/Button';

import SEO from '../../../components/Seo';

import { getSystemSettings, getDestination } from '../../../utils/SettingsRetriever';
import IntlMessage from '../../../LocaleEngine';
import localeAsString from "../../../LocaleEngine/LocaleAsString";

import './index.scss';

export default function NoResultsScreen(props) {
    const configuration = getSystemSettings();

    let logo = 'https://ik.imagekit.io/spotlio/dummy-px_nVIPQQD2f.png';
    if(configuration && configuration.assets && configuration.assets.loading && configuration.assets.loading.logo) {
        logo = configuration.assets.loading.logo;
    }

    const defaultMessages = {
        neutral: {
            neutral: "loadingscreen.messages.default.neutral.noresults",
        },
        lodging: {
            neutral: "loadingscreen.messages.default.lodging.noresults"
        },
        merchandise: {
            neutral: "loadingscreen.messages.default.merchandise.noresults",
        },
        activities: {
            neutral: "loadingscreen.messages.default.activities.noresults",
        },
        shuttle: {
            neutral: "loadingscreen.messages.default.shuttle.noresults",
        },
        rentals: {
            neutral: "loadingscreen.messages.default.rentals.noresults",
        },
        lessons: {
            neutral: "loadingscreen.messages.default.lessons.noresults",
        },
        'lift-tickets': {
            neutral: "loadingscreen.messages.default.lift-tickets.noresults",
        },
        'lift_tickets': {
            neutral: "loadingscreen.messages.default.lift-tickets.noresults",
        },
        'winter-lift-tickets': {
            neutral: "loadingscreen.messages.default.winter-lift-tickets.noresults",
        },
        'winter_lift_tickets': {
            neutral: "loadingscreen.messages.default.winter-lift-tickets.noresults",
        },
        packages: {
            neutral: "loadingscreen.messages.default.packages.noresults",
        },
        package: {
            neutral: "loadingscreen.messages.default.packages.noresults",
        },
        gondola: {
            neutral: "loadingscreen.messages.default.gondola.noresults"
        },
        biking: {
            neutral: "loadingscreen.messages.default.biking.noresults"
        },
        'water-sports': {
            neutral: "loadingscreen.messages.default.water-sports.noresults"
        },
        flights: {
            neutral: "loadingscreen.messages.default.flights.noresults"
        },
        'car-rental': {
            neutral: "loadingscreen.messages.default.car-rental.noresults"
        }
    };

    let section = props.section;
    if (section === '' || typeof section === 'undefined') section = 'neutral';

    let mode = props.mode;
    if (mode === '' || typeof mode === 'undefined') mode = 'neutral';

    let message = ''
    if (!defaultMessages[section] || (defaultMessages[section] && !defaultMessages[section][mode])) message = <IntlMessage id={defaultMessages.neutral.neutral} />
    if (message === '' || typeof message === 'undefined') message = <IntlMessage id={defaultMessages[section][mode]} />;

    if (props.message){
        message = <div dangerouslySetInnerHTML={{ __html: props.message }} />
    }

    if (props.mlos){
        message = <div dangerouslySetInnerHTML={{ __html: props.mlos }} />
    }

    if (getDestination() && getSystemSettings().multiDestination){
        let { multiDestination } = getSystemSettings();
        if (getDestination().length === 1){
            let destination = multiDestination.list.find(dest => dest.id === parseInt(getDestination()[0]));
            let category = destination.config.categories.find(cat => cat.code === props.code);
            if (category && category.config){
                if (category.config.noResults){
                    message = <div dangerouslySetInnerHTML={{ __html: category.config.noResults }} />
                }
                if (category && category.config && category.config.sameDay && props.sameDay){
                    message = <div dangerouslySetInnerHTML={{ __html: category.config.sameDay }} />
                }
            }
        }
    }

    if (props.hasFilters){
        message = <div dangerouslySetInnerHTML={{ __html: localeAsString(defaultMessages[section][mode]).replace("selected dates", "selected filters") }} />
    }

    return (
        <React.Fragment>
            <div className="noResultsBackground" />
            <div className="noResultsScreen">
                <SEO title="No results found" />
                <div className="innerBanner">
                    <img src={logo} alt={configuration.head.title} />
                    <h1>{message}</h1>
                    {
                        props.hasFilters && props.resetFilters 
                        ? <h1 onClick={() => props.resetFilters()}>Reset filters</h1>
                        : null
                    }
                    {
                        props.reloadButton
                        ? <Button className="refreshButton" onClick={() => props.onReload ? props.onReload() : window.location.reload()}>Try other dates</Button>
                        : null
                    }
                </div>
            </div>
        </React.Fragment>
    )
}
